module.exports = __webpack_public_path__ + "img/tb-step-one-img.bda9a2c.svg";